import { Contact } from '@features/contacts/types/contact'

import { BohrSupplier } from '../../../types/bohrSupplier'

export const getContactPrefilledDataFromSupplier = (supplier: BohrSupplier): Partial<Contact> => {
  const {
    contact_id: contactId,
    name,
    phone,
    address_city: city,
    address_street: street,
    address_zip: zipCode,
    vat_no: vatNo,
  } = supplier

  return {
    ...(contactId ? { id: contactId } : {}),
    ...(name ? { name } : {}),
    ...(phone ? { phone } : {}),
    ...(zipCode ? { zipcodeText: zipCode } : {}),
    ...(city ? { cityText: city } : {}),
    ...(street ? { street } : {}),
    ...(vatNo ? { registrationNo: vatNo } : {}),
  }
}
